import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Modal,
} from 'semantic-ui-react';

export default class MultiUnitFormErrors extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool,
    data: PropTypes.oneOfType([
      PropTypes.array,
    ]),
  }
  handleOnClose = (e) => {
    e.preventDefault();
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  render() {
    if (this.props.open) {
      return (
        <Modal
          closeOnEscape={false}
          closeOnDimmerClick={false}
          open
          size="small"
        >
          <Header icon="warning sign" content="Please fix form errors" />
          <Modal.Content>
            <Modal.Description>
              {
                this.props.data.map.length > 0 ?
                this.props.data.map((d, idx) => {
                  let id = idx;
                  id += 1;
                  if (d.errors.reference !== '' || d.errors.size !== '' || d.errors.spaAmount !== '' || d.errors.position !== '') {
                    return (
                      <div key={idx}>
                        <p><b>Row {id}{d.reference !== '' ? ` (${d.reference})` : ''}</b> {d.errors.reference !== '' && <small>{d.errors.reference}. </small>}
                          {d.errors.size !== '' && <small>{d.errors.size}. </small>}
                          {d.errors.spaAmount !== '' && <small>{d.errors.spaAmount}. </small>}
                          {d.errors.position !== '' && <small>{d.errors.position}. </small>}
                        </p>
                      </div>
                    );
                  }
                  return '';
                })
                : ''
              }
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button content="Okay" onClick={this.handleOnClose} />
          </Modal.Actions>
        </Modal>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/containers/modals/MultiUnitFormErrors.jsx